var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.287,
    height: 25.287,
    viewBox: "0 0 25.287 25.287",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-facebook-square",
    "data-name": "Icon awesome-facebook-square",
    d: "M22.578,2.25H2.709A2.709,2.709,0,0,0,0,4.959V24.828a2.709,2.709,0,0,0,2.709,2.709h7.747v-8.6H6.9V14.894h3.556V11.809c0-3.508,2.088-5.446,5.287-5.446a21.543,21.543,0,0,1,3.134.273V10.08H17.112a2.023,2.023,0,0,0-2.281,2.186v2.627h3.882l-.621,4.047H14.831v8.6h7.747a2.709,2.709,0,0,0,2.709-2.709V4.959A2.709,2.709,0,0,0,22.578,2.25Z",
    transform: "translate(0 -2.25)",
    fill: "#575757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacebook);
export default __webpack_public_path__ + "static/media/IconFacebook.101692068c769cf7cbad0b914cf67aed.svg";
export { ForwardRef as ReactComponent };